import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Logo from '../../../../assets/images/logo-1.png';
import Fondo from '../../../../assets/images/fondo-index.svg';
import Cat1 from '../../../../assets/images/categoria1.svg';
import Cat2 from '../../../../assets/images/categoria4.svg';
import Cat3 from '../../../../assets/images/categoria3.svg';
import Cat4 from '../../../../assets/images/categoriaSupport.svg';

import { infoModal } from '../../../Alerts/Alerts';

import './ShowHome.scss';

export default function ShowHome(props) {
    const { categories, setReloadCategories, location } = props;
    const [ postData, setPostData ] = useState({});
    let history = useHistory();
    let arrCat1 = [];
    let arrCat2 = [];
    let arrCat3 = [];
    let arrCat4 = [];

    if(categories){
        arrCat1 = categories.find(el => el.nm_categoria === "Getting Started");
        arrCat2 = categories.find(el => el.nm_categoria === "Advanced Features");
        arrCat3 = categories.find(el => el.nm_categoria === "Notifications");
        arrCat4 = categories.find(el => el.nm_categoria === "PureSocial Support");
    }

    const handleClick = (e) => {
        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;
        let txt_busqueda = '';

        if(postData){
            if(postData.busqueda){
                txt_busqueda = (postData.busqueda)
									.replace(/[ÁÀÄ]/g,"A")
									.replace(/[áàä]/g,"a")
									.replace(/[ÉÈË]/g,"E")
									.replace(/[éèë]/g,"e")
									.replace(/[ÍÌÏ]/g,"I")
									.replace(/[íìï]/g,"i")
									.replace(/[ÓÒÖ]/g,"O")
									.replace(/[óòö]/g,"o")
									.replace(/[ÚÙÜ]/g,"U")
									.replace(/[úùü]/g,"u")
									.replace(/[Ç]/g,"C")
									.replace(/[ç]/g,"c")
									.replace(/[Ñ]/g,"N")
									.replace(/[ñ]/g,"n")
									.replace(/[^a-zA-Z0-9 ]/g, '');
                busqueda = txt_busqueda.trim().replace(/ /g, '-');
            }else{
                infoModal("Information","You must enter a text to search.");
                return;
            }
            if(postData.id_categoria){
                id_cat = postData.id_categoria;
            }
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            
            let busqueda = 0;
            let id_cat = 0;
            let id_sub = 0;
            let txt_busqueda = '';

            if(postData){
                if(postData.busqueda){
                    txt_busqueda = (postData.busqueda)
                                        .replace(/[ÁÀÄ]/g,"A")
                                        .replace(/[áàä]/g,"a")
                                        .replace(/[ÉÈË]/g,"E")
                                        .replace(/[éèë]/g,"e")
                                        .replace(/[ÍÌÏ]/g,"I")
                                        .replace(/[íìï]/g,"i")
                                        .replace(/[ÓÒÖ]/g,"O")
                                        .replace(/[óòö]/g,"o")
                                        .replace(/[ÚÙÜ]/g,"U")
                                        .replace(/[úùü]/g,"u")
                                        .replace(/[Ç]/g,"C")
                                        .replace(/[ç]/g,"c")
                                        .replace(/[Ñ]/g,"N")
                                        .replace(/[ñ]/g,"n")
                                        .replace(/[^a-zA-Z0-9 ]/g, '');
                    busqueda = txt_busqueda.trim().replace(/ /g, '-');
                }else{
                    e.preventDefault();
                    infoModal("Information","You must enter a text to search.");
                    return;
                }
                if(postData.id_categoria){
                    id_cat = postData.id_categoria;
                }
            }

            history.push({
                pathname: '/search',
                search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
                state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
            });
        }
    }

    const handleClickG = (e) => {
        e.preventDefault();

        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;

        if(arrCat1._id){
            id_cat=arrCat1._id;
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });
    }

    const handleClickA = (e) => {
        e.preventDefault();

        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;

        if(arrCat2._id){
            id_cat=arrCat2._id;
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });
    }

    const handleClickP = (e) => {
        e.preventDefault();

        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;

        if(arrCat3._id){
            id_cat=arrCat3._id;
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });
    }

    const handleClickN = (e) => {
        e.preventDefault();

        let busqueda = 0;
        let id_cat = 0;
        let id_sub = 0;

        if(arrCat4._id){
            id_cat=arrCat4._id;
        }

        history.push({
            pathname: '/search',
            search: `?data=${busqueda}&id_cat=${id_cat}&id_sub=${id_sub}`,
            state: [{ data: busqueda, id_cat: id_cat, id_sub: id_sub, prevPath : location.pathname }]
        });
    }

    return (
        <>
            <div className="container-fluid bg-white">
                <div className="row pt-5">
                    <div className="col-12 col-md-6">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-10 m-auto">
                                <div className="row">
                                    <div className="col-8 m-auto text-center">
                                        <img src={Logo} className="w-logo" alt="" />
                                    </div>

                                    <div className="col-12">
                                        <form className="mt-3">
                                            <div className="form-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    id="exampleFormControlInput1" 
                                                    placeholder="Search" 
                                                    maxLength="1000"
                                                    onChange={e => setPostData({ ...postData, busqueda: e.target.value })}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <Category 
                                                    categories={categories} 
                                                    setReloadCategories={setReloadCategories} 
                                                    postData={postData}
                                                    setPostData={setPostData}
                                                />
                                            </div>
                                            <div className="form-group mt-3">
                                                <div className="row">
                                                    <div className="col-6 m-auto">
                                                    <Button 
                                                        className="btn btn-success btn-block"
                                                        onClick={handleClick}
                                                        onKeyDown={handleKeyDown}
                                                    >
                                                        Search
                                                    </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-none d-sm-none d-md-block col-12 col-md-6">
                        <div className="row">
                            <div className="col-8 m-auto text-center">
                                <img className="w-logo" src={Fondo} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-10 m-auto">
                        <div className="row">
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                            <div className="bx-category border shadow p-3">
                                <img src={Cat1} alt="" className="m-auto w-img" />
                                <br/>
                                <Link 
                                    to={""} 
                                    style={{'fontWeight' : 'bold'}}
                                    onClick={handleClickG}
                                >Getting Started</Link>
                                <p className="mt-1 mb-0" style={{"color": "#666", "fontSize": "14px"}} >{ arrCat1 && arrCat1.gl_descripcion ? arrCat1.gl_descripcion : '' }</p>
                            </div>              
                
                            </div>
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                            <div className="bx-category border shadow p-3">
                            <div className="row">
                                <div className="col-6 m-auto">
                                
                                </div>
                            </div>
                            <img src={Cat2} alt="" className="m-auto w-img" />
                            <br/>
                            <Link 
                                    to={''} 
                                    style={{'fontWeight': 'bold'}} 
                                    onClick={handleClickA}
                                >Advanced Features</Link>
                            <p className="mt-1 mb-0" style={{"color": "#666", "fontSize": "14px"}} >{ arrCat2 && arrCat2.gl_descripcion ? arrCat2.gl_descripcion : '' }</p>
                            
                            <div className="clearfix"></div>
                            </div>            
                            </div>
                            
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                
                            <div className="bx-category border shadow p-3">
                                <div className="row">
                                <div className="col-6 m-auto">
                                    
                                </div>
                                </div>
                                <img src={Cat3} alt="" className="m-auto w-img" />
                                <br/>
                                <Link 
                                    to={""} 
                                    style={{'fontWeight': 'bold'}}
                                    onClick={handleClickP}
                                >Notifications</Link>
                                <p className="mt-1 mb-0" style={{"color": "#666", "fontSize": "14px"}} >{ arrCat3 && arrCat3.gl_descripcion ? arrCat3.gl_descripcion : '' }</p>
                                
                                <div className="clearfix"></div>
                            </div>            
                    
                            </div>
                            <div className="col-12 col-sm-6 col-md-3 mt-3">
                
                            <div className="bx-category border shadow p-3">
                            <div className="row">
                                <div className="col-6 m-auto">
                                
                                </div>
                            </div>
                            <img src={Cat4} alt="" className="m-auto w-img" />
                            <br/>
                            <Link 
                                to={""} 
                                style={{'fontWeight': 'bold'}}
                                onClick={handleClickN}
                            >PureSocial Support</Link>
                            <p className="mt-1 mb-0" style={{"color": "#666", "fontSize": "14px"}} >{ arrCat4 && arrCat4.gl_descripcion ? arrCat4.gl_descripcion : '' }</p>
                            
                            <div className="clearfix"></div>
                            </div>            
                
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <div className="row">
                    <footer className="footer">
                        <div className="container">
                            <Link 
                                target={"_blank"} 
                                to={"/termsandconditions"} 
                                className="ml-auto"
                            >
                                Terms and Conditions
                                </Link>
                        </div>
                    </footer>
                </div>
            </div>
        </>
    )
}

function Category (props) {
    const { categories, setPostData, postData } = props;
    
    return(
        <>
          <select 
              className="form-control p-1" 
              onChange={e => setPostData({ ...postData, id_categoria: e.target.value })}
          >
            <option value="0">- Category -</option>
            {categories && categories.map((cat, index) => (
              <option key={index} value={cat._id} >{cat.nm_categoria}</option>
            ))}
          </select>
        </>
    )
  }